<template>
  <div>
    <div class="box d-flex justify-center align-center">
      <div class="text-center">
        <div style="white-space: pre-line;">
          {{ $t('views.welcome.welcome_message') }}
        </div>
        <v-btn
          color="primary"
          href="https://forms.gle/RqzeDGGJcXXeSxBCA"
          target="_blank"
          class="mt-4"
        >
          제안하기
        </v-btn>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
</script>

<style lang="scss" scoped>
.box {
  margin: 20px auto;
  border: 1px solid #dedede;
  background: $white;
  width: 960px;
  height: calc(50vh);
  border-radius: 10px;
}
</style>
